/* SONIOX — Theme JavaScript */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile Menu ---- */
  var menuBtn = document.getElementById('mobileMenuBtn');
  var mobileNav = document.getElementById('mobileNav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  /* ---- Product Gallery Thumbnails ---- */
  var thumbs = document.querySelectorAll('.product-gallery-thumb');
  var mainImg = document.getElementById('galleryMain');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.querySelector('img').src;
      }
    });
  });

  /* ---- Accordion ---- */
  var accBtns = document.querySelectorAll('.accordion-btn');
  accBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = btn.nextElementSibling;
      var isOpen = btn.classList.contains('open');
      accBtns.forEach(function (b) {
        b.classList.remove('open');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
      });
      if (!isOpen) {
        btn.classList.add('open');
        if (body) body.classList.add('open');
      }
    });
  });

  /* ---- Skin Quiz ---- */
  var quizQuestions = document.querySelectorAll('.quiz-question');
  var quizProgress = document.getElementById('quizProgress');
  var currentQ = 0;
  var answers = {};

  function showQuestion(index) {
    quizQuestions.forEach(function (q, i) {
      q.style.display = i === index ? 'block' : 'none';
    });
    if (quizProgress) {
      var pct = ((index) / quizQuestions.length) * 100;
      quizProgress.style.width = pct + '%';
    }
  }

  if (quizQuestions.length > 0) {
    showQuestion(0);
    document.querySelectorAll('.quiz-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var parent = opt.closest('.quiz-question');
        parent.querySelectorAll('.quiz-option').forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        answers[currentQ] = opt.dataset.value;
      });
    });

    var nextBtn = document.getElementById('quizNext');
    var prevBtn = document.getElementById('quizPrev');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentQ < quizQuestions.length - 1) {
          currentQ++;
          showQuestion(currentQ);
        } else {
          var result = document.getElementById('quizResult');
          if (result) {
            document.getElementById('quizForm').style.display = 'none';
            result.style.display = 'block';
            if (quizProgress) quizProgress.style.width = '100%';
          }
        }
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentQ > 0) { currentQ--; showQuestion(currentQ); }
      });
    }
  }

  /* ---- Cart Quantity Buttons ---- */
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var action = btn.dataset.action;
      var numEl = btn.parentElement.querySelector('.qty-num');
      if (!numEl) return;
      var val = parseInt(numEl.textContent, 10);
      if (action === 'plus') numEl.textContent = val + 1;
      if (action === 'minus' && val > 1) numEl.textContent = val - 1;
    });
  });

  /* ---- Sticky Header Shadow ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.style.borderBottomColor = '#333';
      } else {
        header.style.borderBottomColor = '#2A2A2A';
      }
    });
  }

});
